
import React, { useState, useEffect } from 'react';
import { useContext } from 'react';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import './action.css';
import { AgenceContext } from '../../context/agenceContext/AgenceContext';
import { useNavigate, useParams } from 'react-router-dom';
import { actionsPaiement, typeActionsEnvois, } from '../../data';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import FilterInput from '../../components/filterInput/FilterInput';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls';
import { DeliveryContext } from '../../context/deliveryContext/DeliveryContext';
import { getLivreurs, getTransporteurs } from '../../context/deliveryContext/apiCalls';
import SubLoadingComponent from '../../components/subLoadingComponent/SubLoadingComponent';
import ModalComponent from '../../components/modalComponent/ModalComponent';
import FormTextArea from '../../components/formTextArea/FormTextArea';
import { ActionEnvoieContext } from '../../context/actionEnvoieContext/ActionEnvoieContext';
import { addActionEnvoie, getActionsEnvois, updateActionEnvoie } from '../../context/actionEnvoieContext/apiCalls';
import FilterDateInput from '../../components/filterDateInput/FilterDateInput';
import { AuthContext } from '../../context/authContext/AuthContext';

function Action() {
    const { dispatch, actionsEnvois, isFetching, error, count: pages, actionEnvoie, isFetchingAdd, errorAdd, isFetchingUpdate, errorUpdate, actionEnvoieUpdate } = useContext(ActionEnvoieContext);
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);
    const { dispatch: dispatchDelivery, transporteurs, livreurs } = useContext(DeliveryContext);
    const { user } = useContext(AuthContext);

    const { page = 1 } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);

    const [id, setId] = useState("");
    const [typeActionEnvoie, setTypeActionEnvoie] = useState({ nom: "Choisir Type", id: 0, });
    const [agence, setAgence] = useState({ nom: "Choisir Agence", id: 0, });
    const [transporteur, setTransporteur] = useState({ nom: "Choisir Transporteur", id: 0, });
    const [livreur, setLivreur] = useState({ nom: "Choisir Livreur", id: 0, });
    const [paiement, setPaiement] = useState(actionsPaiement[1]);
    const [dateEnvoie, setDateEnvoie] = useState("");

    useEffect(() => {
        getActionsEnvois(dispatch, pageSize, page, id, typeActionEnvoie.id, agence.id, transporteur.id, livreur.id, dateEnvoie, paiement.id);
    }, [dispatch, pageSize, page, id, typeActionEnvoie, agence, transporteur, livreur, dateEnvoie, paiement])

    useEffect(() => {
        navigate(`/actions/1`);
    }, [id, typeActionEnvoie, agence, transporteur, livreur, dateEnvoie, paiement])

    useEffect(() => {
        getAgencesByWilaya(dispatchAgence);
        getTransporteurs(dispatchDelivery);
        getLivreurs(dispatchDelivery);
    }, [])

    /**************  Ajouter Modal  **************/
    const [modalAddActive, setModalAddActive] = useState(false);
    const [addDescription, setAddDescription] = useState("");
    const [addTypeActionEnvoie, setAddTypeActionEnvoie] = useState({ nom: "Choisir Type", id: 0, });
    const [addAgence, setAddAgence] = useState({ nom: "Choisir Agence", id: 0, });
    const [addTransporteur, setAddTransporteur] = useState({ nom: "Choisir Transporteur", id: 0, });
    const [addLivreur, setAddLivreur] = useState({ nom: "Choisir Livreur", id: 0, });
    const [addErrorBox, setAddErrorBox] = useState("");

    useEffect(() => {
        if (Object.keys(actionEnvoie).length !== 0) {
            getActionsEnvois(dispatch, pageSize, page, id, typeActionEnvoie.id, agence.id, transporteur.id, livreur.id);
            setAddTypeActionEnvoie({ nom: "Choisir Type", id: 0, });
            setAddAgence({ nom: "Choisir Agence", id: 0, });
            setAddTransporteur({ nom: "Choisir Transporteur", id: 0, });
            setAddLivreur({ nom: "Choisir Livreur", id: 0, });
            setAddDescription('');

            setModalAddActive(false);
            setAddErrorBox("");
        }
    }, [actionEnvoie])

    useEffect(() => {
        if (errorAdd != false) {
            setAddErrorBox(errorAdd);
            setModalAddActive(true);
        }
    }, [errorAdd])

    const handleAddAction = () => {
        if (addTypeActionEnvoie.id === 0) {
            setAddErrorBox('Vous devez définir le Type');
            return;
        }
        if (addAgence.id === 0) {
            setAddErrorBox("Vous devez définir l'agence");
            return;
        }
        if ((addTypeActionEnvoie.id === 1) || (addTypeActionEnvoie.id === 5)) {
            if (addLivreur.id === 0) {
                setAddErrorBox("Vous devez définir le livreur");
                return;
            }
        }
        if ((addTypeActionEnvoie.id === 3) || (addTypeActionEnvoie.id === 4)) {
            if (addTransporteur.id === 0) {
                setAddErrorBox("Vous devez définir le transporteur");
                return;
            }
        }

        if ((addTypeActionEnvoie.id === 1) || (addTypeActionEnvoie.id === 5)) {
            addActionEnvoie(dispatch, addTypeActionEnvoie.id, addAgence.id, addLivreur.id, addDescription);
            return;
        }
        if ((addTypeActionEnvoie.id === 3) || (addTypeActionEnvoie.id === 4)) {
            addActionEnvoie(dispatch, addTypeActionEnvoie.id, addAgence.id, addTransporteur.id, addDescription);
            return;
        }

        addActionEnvoie(dispatch, addTypeActionEnvoie.id, addAgence.id, null, addDescription);
    }

    const getStatusClass = (statusCode) => {
        if (statusCode === 10) {
            return "preparation"
        } else if (statusCode === 1) {
            return "ramassage"
        } else if (statusCode === 8) {
            return "reception-agence"
        } else if (statusCode === 2) {
            return "depot-agence"
        } else if (statusCode === 3) {
            return "acheminement-depart"
        } else if (statusCode === 4) {
            return "acheminement-arrive"
        } else if (statusCode === 5) {
            return "livraison-domicile"
        } else if (statusCode === 6) {
            return "livraison-agence"
        } else if (statusCode === 9) {
            return "stock-agence"
        } else if (statusCode === 11) {
            return "retour-client"
        }else {
            return "stock-agence"
        }
    }

    /**************  Update Modal  **************/
    const [modalUpdateActive, setModalUpdateActive] = useState(false);
    const [updateId, setUpdateId] = useState("");
    const [updateDescription, setUpdateDescription] = useState("");
    const [updateTypeActionEnvoie, setUpdateTypeActionEnvoie] = useState({ nom: "Choisir Type", id: 0, });
    const [updateAgence, setUpdateAgence] = useState({ nom: "Choisir Agence", id: 0, });
    const [updateTransporteur, setUpdateTransporteur] = useState({ nom: "Choisir Transporteur", id: 0, });
    const [updateLivreur, setUpdateLivreur] = useState({ nom: "Choisir Livreur", id: 0, });
    const [updateErrorBox, setUpdateErrorBox] = useState("");

    const updateModalUpdateActive = (id, type, agence, delivery, description) => {
        setModalUpdateActive(true);
        setUpdateId(id);
        setUpdateTypeActionEnvoie(typeActionsEnvois.filter(item => item.id === type)[0]);
        setUpdateAgence(agencesByWilaya.filter(item => item.id === agence)[0]);
        ((type === 1) || (type === 5)) && (
            setUpdateLivreur(livreurs.filter(item => item.id === delivery)[0])
        );
        ((type === 3) || (type === 4)) && (
            setUpdateTransporteur(transporteurs.filter(item => item.id === delivery)[0])
        );
        setUpdateDescription(description)
    }

    useEffect(() => {
        if (Object.keys(actionEnvoieUpdate).length !== 0) {
            getActionsEnvois(dispatch, pageSize, page, id, typeActionEnvoie.id, agence.id, transporteur.id, livreur.id);
            setUpdateTypeActionEnvoie({ nom: "Choisir Type", id: 0, });
            setUpdateAgence({ nom: "Choisir Agence", id: 0, });
            setUpdateTransporteur({ nom: "Choisir Transporteur", id: 0, });
            setUpdateLivreur({ nom: "Choisir Livreur", id: 0, });
            setUpdateDescription('');

            setModalUpdateActive(false);
            setUpdateErrorBox("");
        }
    }, [actionEnvoieUpdate])

    useEffect(() => {
        if (errorUpdate != false) {
            setUpdateErrorBox(errorUpdate);
            setModalUpdateActive(true);
        }
    }, [errorUpdate])

    const handleUpdateAgence = () => {
        if (updateTypeActionEnvoie.id === 0) {
            setAddErrorBox('Vous devez définir le Type');
            return;
        }
        if (updateAgence.id === 0) {
            setAddErrorBox("Vous devez définir l'agence");
            return;
        }
        if ((updateTypeActionEnvoie.id === 1) || (updateTypeActionEnvoie.id === 5)) {
            if (updateLivreur.id === 0) {
                setAddErrorBox("Vous devez définir le livreur");
                return;
            }
        }
        if ((updateTypeActionEnvoie.id === 3) || (updateTypeActionEnvoie.id === 4)) {
            if (updateTransporteur.id === 0) {
                setAddErrorBox("Vous devez définir le transporteur");
                return;
            }
        }

        if ((updateTypeActionEnvoie.id === 1) || (updateTypeActionEnvoie.id === 5)) {
            updateActionEnvoie(dispatch, updateId, updateTypeActionEnvoie.id, updateAgence.id, updateLivreur.id, updateDescription);
            return;
        }
        if ((updateTypeActionEnvoie.id === 3) || (updateTypeActionEnvoie.id === 4)) {
            updateActionEnvoie(dispatch, updateId, updateTypeActionEnvoie.id, updateAgence.id, updateTransporteur.id, updateDescription);
            return;
        }

        updateActionEnvoie(dispatch, updateId, updateTypeActionEnvoie.id, updateAgence.id, null, updateDescription);
    }
    
    return (
        <div className='container-global'>
            <AdminSideBar activeTab="action" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Actions :</span>
                </div>

                {
                    error ? <ErrorComponent error={error} /> : (
                        <>
                            <div className="filter">
                                <span className="adv-research">Recherche Avancée</span>
                                <div className="filter-content">
                                    {/* <FilterInput placeholder={'ID'} setItem={setId} /> */}
                                    <DropDownComponent data={[{ nom: "Choisir Type", id: 0, }, ...typeActionsEnvois]} itemChoisir={typeActionEnvoie} setItemChoisir={setTypeActionEnvoie} filter />
                                    {
                                        (user.role === 1 || user.role === 2) && (
                                            <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya]} itemChoisir={agence} setItemChoisir={setAgence} filter />
                                        )
                                    }
                                    <DropDownComponent data={[{ nom: "Choisir Transporteur", id: 0, }, ...transporteurs]} itemChoisir={transporteur} setItemChoisir={setTransporteur} filter />
                                    {
                                        (user.role === 1 || user.role === 2) ? (
                                            <DropDownComponent data={[{ nom: "Choisir Livreur", id: 0, }, ...livreurs]} itemChoisir={livreur} setItemChoisir={setLivreur} filter />
                                        ) : (
                                            <DropDownComponent data={[{ nom: "Choisir Livreur", id: 0, }, ...(livreurs.filter(item => item.AgenceId === user.agence))]} itemChoisir={livreur} setItemChoisir={setLivreur} filter />
                                        )
                                    }
                                    <DropDownComponent data={actionsPaiement} itemChoisir={paiement} setItemChoisir={setPaiement} filter />
                                    <FilterDateInput placeholder={"Date"} item={dateEnvoie} setItem={setDateEnvoie} />
                                </div>
                            </div>

                            <div className="add-item">
                                <span className='color-1' onClick={() => navigate('/actions/create')}>Ajouter Action</span>
                            </div>

                            {
                                isFetching ? <LoadingComponent /> : (
                                    actionsEnvois.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                                        : (
                                            <>
                                                <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation='actions' />
                                                <div className="content">
                                                    {
                                                        <>
                                                            <TableComponent headers={['type', 'Agence', "Agence d'Arrivé", 'Transporteur/Livreur', 'Utilisateur', 'Date', 'Action']}>
                                                                {
                                                                    actionsEnvois.map((actionEnvoie, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                <span className={`table-special ${getStatusClass(actionEnvoie.type)}`}>{typeActionsEnvois.filter(item => item.id == actionEnvoie.type)[0]['nom']}</span>
                                                                            </td>
                                                                            <td>{actionEnvoie.agenceDepartureActionAlias ? actionEnvoie.agenceDepartureActionAlias.nom : (<span className="material-symbols-rounded">align_vertical_center</span>)} </td>
                                                                            <td>{actionEnvoie.agenceArrivedActionAlias ? actionEnvoie.agenceArrivedActionAlias.nom : (<span className="material-symbols-rounded">align_vertical_center</span>)} </td>
                                                                            <td>{actionEnvoie.userActionDeliveryAlias ? actionEnvoie.userActionDeliveryAlias.username : (<span className="material-symbols-rounded">align_vertical_center</span>)} </td>
                                                                            <td>{actionEnvoie.userActionCreatorAlias ? actionEnvoie.userActionCreatorAlias.username : (<span className="material-symbols-rounded">align_vertical_center</span>)} </td>
                                                                            <td>{actionEnvoie.createdAt.slice(0, 10)}</td>
                                                                            <td>
                                                                                {/* {
                                                                                    (user.role === 1 || user.role === 2) && (
                                                                                        <span className='update' onClick={() => updateModalUpdateActive(actionEnvoie.id, actionEnvoie.type, actionEnvoie.agenceDepartureActionAlias.id, actionEnvoie.userActionDeliveryAlias ? actionEnvoie.userActionDeliveryAlias.id : null, actionEnvoie.description || "")}>Update</span>
                                                                                    )
                                                                                } */}
                                                                                <span className='detail' onClick={() => navigate(`/actions/${actionEnvoie.id}/bagages/1`)}>Detail</span>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </TableComponent>
                                                            {
                                                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item='actions' />)
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>
                                        )
                                )
                            }
                        </>
                    )
                }

            </div>


            {/*  Modal Components */}
            {
                <>
                    <ModalComponent modalActive={modalAddActive} setModalActive={setModalAddActive} setErrorBox={setAddErrorBox} title="Ajouter Action">
                        {
                            isFetchingAdd ? <SubLoadingComponent /> : (
                                <form>
                                    {addErrorBox !== "" && (<div className='box-error'>{addErrorBox}</div>)}
                                    <DropDownComponent data={[{ nom: "Choisir Type", id: 0, }, ...typeActionsEnvois]} itemChoisir={addTypeActionEnvoie} setItemChoisir={setAddTypeActionEnvoie} filter />
                                    <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya]} itemChoisir={addAgence} setItemChoisir={setAddAgence} filter />
                                    {
                                        ((addTypeActionEnvoie.id === 1) || (addTypeActionEnvoie.id === 5)) && (
                                            <DropDownComponent data={[{ nom: "Choisir Livreur", id: 0, }, ...livreurs]} itemChoisir={addLivreur} setItemChoisir={setAddLivreur} filter />
                                        )
                                    }
                                    {
                                        ((addTypeActionEnvoie.id === 3) || (addTypeActionEnvoie.id === 4)) && (
                                            <DropDownComponent data={[{ nom: "Choisir Livreur", id: 0, }, ...transporteurs]} itemChoisir={addTransporteur} setItemChoisir={setAddTransporteur} filter />
                                        )
                                    }
                                    <FormTextArea label='Description' itemInput={addDescription} setItemInput={setAddDescription} auth />
                                    <div className='button' onClick={handleAddAction}>
                                        <span>Valider</span>
                                    </div>
                                </form>
                            )
                            // )
                        }
                    </ModalComponent>

                    <ModalComponent modalActive={modalUpdateActive} setModalActive={setModalUpdateActive} setErrorBox={setUpdateErrorBox} title="Modifier Action">
                        {
                            isFetchingUpdate ? <SubLoadingComponent /> : (
                                <form>
                                    {updateErrorBox !== "" && (<div className='box-error'>{updateErrorBox}</div>)}
                                    <DropDownComponent data={[{ nom: "Choisir Type", id: 0, }, ...typeActionsEnvois]} itemChoisir={updateTypeActionEnvoie} setItemChoisir={setUpdateTypeActionEnvoie} filter />
                                    <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya]} itemChoisir={updateAgence} setItemChoisir={setUpdateAgence} filter />
                                    {
                                        ((updateTypeActionEnvoie.id === 1) || (updateTypeActionEnvoie.id === 5)) && (
                                            <DropDownComponent data={[{ nom: "Choisir Livreur", id: 0, }, ...livreurs]} itemChoisir={updateLivreur} setItemChoisir={setUpdateLivreur} filter />
                                        )
                                    }
                                    {
                                        ((updateTypeActionEnvoie.id === 3) || (updateTypeActionEnvoie.id === 4)) && (
                                            <DropDownComponent data={[{ nom: "Choisir Livreur", id: 0, }, ...transporteurs]} itemChoisir={updateTransporteur} setItemChoisir={setUpdateTransporteur} filter />
                                        )
                                    }
                                    <FormTextArea label='Description' itemInput={updateDescription} setItemInput={setUpdateDescription} auth />
                                    <div className='button' onClick={handleUpdateAgence}>
                                        <span>Valider</span>
                                    </div>
                                </form>
                            )
                        }
                    </ModalComponent>
                </>
            }
            {/*  End Modal Components */}


        </div>
    )
}
export default Action